var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"m-b-50 m-t-20 min-h-570"},[_c('div',{staticClass:"min-h-570",staticStyle:{"width":"1200px","margin":"40px auto","margin-left":"40%"}},[_c('Coupon',{attrs:{"couponList":_vm.couponList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }